import { useLocation } from "react-router";
import { useState } from "react";
import ReactWhatsapp from "react-whatsapp";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import { LayoutType } from "../interfaces";
import { FaWhatsapp } from "react-icons/fa6";
import { FaPaperPlane } from "react-icons/fa";

const AppLayout = ({ children }: LayoutType) => {
  const { pathname } = useLocation();
  const [supportSubject, setSupportSubject] = useState("پشتیبانی فنی");
  const [supportMessage, setSupportMessage] = useState("");

  const formatWhatsAppMessage = () => {
    const currentUrl = window.location.href;
    return `${currentUrl}, ${supportSubject}, ${supportMessage}`;
  };

  return (
    <div className={`min-h-screen duration-500 bg-pr_background`}>
      {pathname === "/intro" ? (
        <div className="h-screen overflow-hidden">{children}</div>
      ) : (
        <>
          <div
            className={`${
              pathname === "/login"
                ? ""
                : "lg:relative sticky lg:top-auto top-0 lg:bg-transparent bg-white pb-2 lg:pb-0 z-[1000] border-b-[1px] lg:border-none"
            }`}
          >
            <Navbar />
          </div>
          <div
            className={`lg:max-w-[1300px] mx-auto flex justify-between py-2 lg:px-1 px-3`}
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: "calc(100vh - 110px)",
            }}
          >
            {children}
          </div>
          <Footer />
        </>
      )}

      {/* <button //@ts-ignore
        onClick={() => document.getElementById("support").showModal()}
        className="fixed right-2 bottom-2 w-14 h-14 rounded-full bg-pr_green_dark text-white flex items-center justify-center z-100"
      >
        <FaWhatsapp size={30} />
      </button>
      <dialog id="support" className="modal">
        <div className="modal-box flex flex-col items-center">
          <h3 className="font-bold text-lg font-rokh font-[900] mt-3 mb-4">
            پشتیبانی بادی‌بان
          </h3>

          <div className="w-full mb-4">
            <label className="block text-right mb-2 text-sm font-medium">
              موضوع پیام
            </label>
            <select
              value={supportSubject}
              onChange={(e) => setSupportSubject(e.target.value)}
              className="w-full p-2.5 text-right border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="پشتیبانی فنی">پشتیبانی فنی</option>
              <option value="مدیریت">مدیریت</option>
              <option value="پیشنهاد">پیشنهاد</option>
            </select>
          </div>

          <div className="w-full mb-4">
            <label className="block text-right mb-2 text-sm font-medium">
              متن پیام
            </label>
            <textarea
              value={supportMessage}
              onChange={(e) => setSupportMessage(e.target.value)}
              rows={4}
              className="w-full p-2.5 text-right border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              placeholder="پیام خود را بنویسید..."
            ></textarea>
          </div>

          <ReactWhatsapp
            number="+989373909698"
            message={formatWhatsAppMessage()}
            element="button"
            disabled={!supportMessage.trim()}
            className={`w-full flex items-center justify-center gap-2 p-2.5 rounded-lg ${
              supportMessage.trim()
                ? "bg-pr_green_dark text-white hover:bg-pr_green"
                : "bg-gray-200 text-gray-500 cursor-not-allowed"
            }`}
          >
            <FaPaperPlane size={16} />
            <span>ارسال پیام به واتساپ</span>
          </ReactWhatsapp>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog> */}
    </div>
  );
};

export default AppLayout;
